import { render, staticRenderFns } from "./ContabilitaArticoliMagazzinoDettagliListComponent.vue?vue&type=template&id=63acceea"
import script from "./ContabilitaArticoliMagazzinoDettagliListComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaArticoliMagazzinoDettagliListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports